/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
import { DataTableHeadCellV2, DataTableHeadV2, DataTableRowV2 } from '@americanexpress/dls-react';
import React from 'react';
import * as PropTypes from 'prop-types';
import { useEnhancedDataTableContext } from './EnhancedDataTableContext';

let dragItemIndex = -1;
let dragItemId = '';

const EnhancedHeader = React.memo(({
  isEmpty,
  onHeaderPosChange,
}) => {
  const context = useEnhancedDataTableContext();

  const { tableNm } = context;
  const { headers } = context;
  const { checkable } = context;
  const { singleRowSelect } = context;
  const { inlineItemAction = false } = context;
  const { sortable } = context;
  const { showFilter } = context;
  const { defaultColumn } = context;
  const { hasDefaultColumn } = defaultColumn;
  const { expandable } = context;
  const { showLoader } = context;
  //  const onHeaderPosChange = context.onHeaderPosChange

  const getEmptyHeader = () => {
    const isExpandable = expandable === undefined ? false : expandable;
    if (isExpandable) {
      return <></>;
    }
    return (
      <DataTableHeadCellV2
        id={`${tableNm}-cell-empty`}
        style={{
          whiteSpace: 'break-spaces',
          wordBreak: 'normal',
        }}
      />
    );
  };

  const handleDragStart = (e, colIdx, hId) => {
    if (onHeaderPosChange) {
      dragItemId = hId;
      dragItemIndex = colIdx;
    }
  };

  const handleDragEnd = (e, colIdx) => {
    if (onHeaderPosChange) {
      e.target.style.borderLeft = e.target.style.borderRight;
      if (e.target.parentElement?.parentElement?.parentElement?.rows) {
        e.target.parentElement?.parentElement?.parentElement?.rows.forEach((r) => {
          r.cells[colIdx + 1].style.borderLeft = r.cells[colIdx + 1].style.borderRight;
        });
      }
    }
  };

  const handleDragEnter = (e, colIdx) => {
    if (onHeaderPosChange) {
      e.target.style.borderLeft = '2px solid black';
      if (e.target.parentElement?.parentElement?.parentElement?.rows) {
        e.target.parentElement?.parentElement?.parentElement?.rows.forEach((r) => {
          r.cells[colIdx + 1].style.borderLeft = '2px solid black';
        });
      }
    }
  };

  const handleDragLeave = (e, colIdx) => {
    if (onHeaderPosChange) {
      e.target.style.borderLeft = e.target.style.borderRight;
      if (e.target.parentElement?.parentElement?.parentElement?.rows) {
        e.target.parentElement?.parentElement?.parentElement?.rows.forEach((r) => {
          r.cells[colIdx + 1].style.borderLeft = r.cells[colIdx + 1].style.borderRight;
        });
      }
    }
  };

  function getDefaultColumn() {
    if (hasDefaultColumn) {
      return (
        <DataTableHeadCellV2
          id={`${tableNm}-cell-default`}
          style={{
            whiteSpace: 'break-spaces',
            wordBreak: 'normal',
          }}
        > DEFAULT
        </DataTableHeadCellV2>
      );
    }
    return <> </>;
  }

  // eslint-disable-next-line complexity
  const handleDrop = (e, colIdx, hId) => {
    if (onHeaderPosChange && dragItemIndex !== colIdx) {
      const destHeader = headers.find((h) => h.id === hId);
      const sourceHeader = headers.find((h) => h.id === dragItemId);
      if (destHeader && sourceHeader) {
        //   [destHeader.sNo,sourceHeader.sNo]= [sourceHeader.sNo,destHeader.sNo];
        const rowIndex = headers.findIndex((obj) => obj.sNo === sourceHeader.sNo);

        headers.splice(rowIndex, 1);
        if (dragItemIndex > colIdx) {
          headers.splice(colIdx, 0, sourceHeader);
          // 1st conditon -> 12 is Max no of colums, 2nd Condition for tables which have columns less then 12
        } else if (colIdx === 11 || colIdx === headers.length) {
          headers.splice(headers.length, 0, sourceHeader);
        } else {
          let newColIdx = 0;
          // eslint-disable-next-line no-restricted-syntax
          for (const arrayIndex in headers) {
            if (headers[arrayIndex].display) {
              newColIdx += 1;
              if (newColIdx === colIdx) {
                headers.splice(arrayIndex, 0, sourceHeader);
                break;
              }
            }
          }
        }
        onHeaderPosChange(headers);
        e.target.style.borderLeft = e.target.style.borderRight;
        if (e.target.parentElement?.parentElement?.parentElement?.rows) {
          e.target.parentElement?.parentElement?.parentElement?.rows.forEach((r) => {
            r.cells[colIdx + 1].style.borderLeft = r.cells[colIdx + 1].style.borderRight;
          });
        }
      }
    }
  };

  if ((checkable && singleRowSelect) || (showFilter && checkable && !singleRowSelect && showLoader)) {
    if (inlineItemAction) {
      return (
        <DataTableHeadV2 id={`${tableNm}-header`}>
          <DataTableRowV2 id={`${tableNm}-header-tableRow`}>
            {
              headers.filter((h) => h?.display === true)
                .map((header, colIdx) => (
                  <DataTableHeadCellV2
                    key={header.id}
                    style={{
                      whiteSpace: 'break-spaces',
                      wordBreak: 'normal',
                    }}
                    align="left"
                    id={`${tableNm}-cell-${header.id}`}
                    colIndex={colIdx}
                    sortable={sortable}
                    draggable={true}
                    onDragStart={(e) => handleDragStart(e, colIdx, header.id, header.sNo)}
                    onDragEnd={(e) => handleDragEnd(e, colIdx, header.id, header.sNo)}
                    onDragEnter={(e) => handleDragEnter(e, colIdx, header.id, header.sNo)}
                    onDragLeave={(e) => handleDragLeave(e, colIdx, header.id, header.sNo)}
                    onDrop={(e) => handleDrop(e, colIdx, header.id, header.sNo)}
                    onDragOver={(e) => e.preventDefault()}
                  >
                    {header.label}
                  </DataTableHeadCellV2>
                )
                )
            }
            <DataTableHeadCellV2
              id={`${tableNm}-cell-empty`}
              style={{
                whiteSpace: 'break-spaces',
                wordBreak: 'normal',
              }}
            >
              ACTIONS
            </DataTableHeadCellV2>
            {getDefaultColumn()}
          </DataTableRowV2>
        </DataTableHeadV2>
      );
    }
    return (
      <DataTableHeadV2 id={`${tableNm}-header`}>
        <DataTableRowV2 id={`${tableNm}-header-tableRow`}>
          {getEmptyHeader()}
          {
            headers.filter((h) => h?.display === true)
              .map((header, colIdx) => (
                <DataTableHeadCellV2
                  key={header.id}
                  style={{
                    whiteSpace: 'break-spaces',
                    wordBreak: 'normal',
                  }}
                  align="left"
                  id={`${tableNm}-cell-${header.id}`}
                  colIndex={colIdx}
                  sortable={sortable}
                  draggable={true}
                  onDragStart={(e) => handleDragStart(e, colIdx, header.id, header.sNo)}
                  onDragEnd={(e) => handleDragEnd(e, colIdx, header.id, header.sNo)}
                  onDragEnter={(e) => handleDragEnter(e, colIdx, header.id, header.sNo)}
                  onDragLeave={(e) => handleDragLeave(e, colIdx, header.id, header.sNo)}
                  onDrop={(e) => handleDrop(e, colIdx, header.id, header.sNo)}
                  onDragOver={(e) => e.preventDefault()}
                >
                  {header.label}
                </DataTableHeadCellV2>
              )
              )
          }
          {getDefaultColumn()}
        </DataTableRowV2>
      </DataTableHeadV2>
    );
  }

  if (showFilter && (!checkable || isEmpty)) {
    return (
      <DataTableHeadV2 id={`${tableNm}-header`}>
        <DataTableRowV2 id={`${tableNm}-header-row`}>
          {getEmptyHeader()}
          {
            headers.filter((h) => h?.display === true)
              .map((header, colIdx) => (
                <DataTableHeadCellV2
                  key={header.id}
                  style={{
                    whiteSpace: 'break-spaces',
                    wordBreak: 'normal',
                  }}
                  id={`${tableNm}-cell-${header.id}`}
                  colIndex={colIdx}
                  sortable={sortable}
                  draggable={true}
                  onDragStart={(e) => handleDragStart(e, colIdx, header.id, header.sNo)}
                  onDragEnd={(e) => handleDragEnd(e, colIdx, header.id, header.sNo)}
                  onDragEnter={(e) => handleDragEnter(e, colIdx, header.id, header.sNo)}
                  onDragLeave={(e) => handleDragLeave(e, colIdx, header.id, header.sNo)}
                  onDrop={(e) => handleDrop(e, colIdx, header.id, header.sNo)}
                  onDragOver={(e) => e.preventDefault()}
                >
                  {header.label}
                </DataTableHeadCellV2>
              )
              )
          }
          {getDefaultColumn()}
        </DataTableRowV2>
      </DataTableHeadV2>
    );
  }

  return (
    <DataTableHeadV2 id={`${tableNm}-header`}>
      <DataTableRowV2 id={`${tableNm}-header-row`}>
        {
          headers.filter((h) => h?.display === true)
            .map((header, colIdx) => (
              <DataTableHeadCellV2
                key={header.id}
                style={{
                  whiteSpace: 'break-spaces',
                  wordBreak: 'normal',
                }}
                id={`${tableNm}-cell-${header.id}`}
                colIndex={colIdx}
                sortable={sortable}
                draggable={true}
                onDragStart={(e) => handleDragStart(e, colIdx, header.id, header.sNo)}
                onDragEnd={(e) => handleDragEnd(e, colIdx, header.id, header.sNo)}
                onDragEnter={(e) => handleDragEnter(e, colIdx, header.id, header.sNo)}
                onDragLeave={(e) => handleDragLeave(e, colIdx, header.id, header.sNo)}
                onDrop={(e) => handleDrop(e, colIdx, header.id, header.sNo)}
                onDragOver={(e) => e.preventDefault()}
              >
                {header.label}
              </DataTableHeadCellV2>
            )
            )
        }
        {getDefaultColumn()}
      </DataTableRowV2>
    </DataTableHeadV2>
  );
});

EnhancedHeader.displayName = 'EnhancedHeader';

EnhancedHeader.propTypes = {
  isEmpty: PropTypes.bool.isRequired,
  onHeaderPosChange: PropTypes.func.isRequired,
};

export default EnhancedHeader;
